// src/utils/roomValidation.js

export const fetchRoomsData = async (property, IP, hotelId = null) => {
  try {
    const url = `${IP}/tavpos/backend/data/${encodeURIComponent(property)}/rooms.json`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('No se pudo cargar la configuración de habitaciones');
    }
    const data = await response.json();
    
    // Si hay múltiples hoteles y se especifica uno, filtrar
    if (data.hoteles && data.hoteles.length > 0) {
      if (hotelId) {
        const hotel = data.hoteles.find(h => h.id === hotelId && h.activo === 'Y');
        return hotel ? hotel.rooms || [] : [];
      }
      // Si no se especifica hotel, devolver el primero activo
      const activeHotel = data.hoteles.find(h => h.activo === 'Y');
      return activeHotel ? activeHotel.rooms || [] : [];
    }
    
    // Compatibilidad con formato anterior
    return data.rooms || [];
  } catch (error) {
    console.error('Error loading rooms.json:', error);
    return [];
  }
};

export const fetchHotels = async (property, IP) => {
  try {
    const url = `${IP}/tavpos/backend/data/${encodeURIComponent(property)}/rooms.json`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('No se pudo cargar la configuración');
    }
    const data = await response.json();
    
    if (data.hoteles && data.hoteles.length > 0) {
      return data.hoteles.filter(hotel => hotel.activo === 'Y');
    }
    
    // Si no hay hoteles, crear uno por defecto
    return [{ id: 'default', nombre: 'Hotel Principal', activo: 'Y', rooms: data.rooms || [] }];
  } catch (error) {
    console.error('Error loading hotels:', error);
    return [];
  }
};

export const validateRoom = (roomNumber, roomsData) => {
  const roomNumberStr = String(roomNumber).trim();
  
  const room = roomsData.find(r => String(r.room) === roomNumberStr);
  
  if (!room) {
    return { 
      valid: false, 
      error: `La habitación ${roomNumberStr} no existe en el sistema` 
    };
  }
  
  if (room.activa !== 'Y') {
    return { 
      valid: false, 
      error: `La habitación ${roomNumberStr} no está activa (deshabilitada)` 
    };
  }
  
  return { 
    valid: true, 
    roomInfo: room,
    error: null 
  };
};

export const getActiveRooms = (roomsData) => {
  return roomsData.filter(room => room.activa === 'Y');
};

export const getInactiveRooms = (roomsData) => {
  return roomsData.filter(room => room.activa !== 'Y');
};

export const getRoomsByFloor = (roomsData) => {
  const floors = {};
  const activeRooms = getActiveRooms(roomsData);
  const inactiveRooms = getInactiveRooms(roomsData);
  
  // Procesar todas las habitaciones para tener floor plan completo
  const allRooms = [...activeRooms, ...inactiveRooms];
  
  allRooms.forEach(room => {
    if (!floors[room.floor]) {
      floors[room.floor] = { active: [], inactive: [] };
    }
    if (room.activa === 'Y') {
      floors[room.floor].active.push(room);
    } else {
      floors[room.floor].inactive.push(room);
    }
  });
  
  // Ordenar pisos
  const sortedFloors = Object.keys(floors)
    .map(Number)
    .sort((a, b) => a - b);
  
  sortedFloors.forEach(floor => {
    floors[floor].active.sort((a, b) => a.room - b.room);
    floors[floor].inactive.sort((a, b) => a.room - b.room);
  });
  
  return { floors, sortedFloors };
};

export const getAllRoomsByFloor = (roomsData) => {
  const floors = {};
  
  roomsData.forEach(room => {
    if (!floors[room.floor]) {
      floors[room.floor] = [];
    }
    floors[room.floor].push(room);
  });
  
  const sortedFloors = Object.keys(floors)
    .map(Number)
    .sort((a, b) => a - b);
  
  sortedFloors.forEach(floor => {
    floors[floor].sort((a, b) => a.room - b.room);
  });
  
  return { floors, sortedFloors };
};